import { ParentComponent } from "solid-js";

export const BlockGrid: ParentComponent = (props) => (
    <div class="b-block-grid">{props.children}</div>
);

export const BlockGridItem: ParentComponent = (props) => (
    <div class="b-block-grid__item">{props.children}</div>
);